/* Cellform — bundle page: flavour choice per item, live total, add every chosen item to the cart in one request. */
(() => {
  if (customElements.get('bundle-picker')) return;
  const C = window.Cellform || {};
  const money = (cents) => (C.formatMoney ? C.formatMoney(cents) : '£' + (cents / 100).toFixed(2));

  customElements.define('bundle-picker', class extends HTMLElement {
    connectedCallback() {
      this.pct = Number(this.dataset.savingPercent) || 0;
      this.form = this.querySelector('[data-bundle-form]');
      this.button = this.querySelector('[data-bundle-submit]');
      this.error = this.querySelector('[data-bundle-error]');
      this.items = [...this.querySelectorAll('[data-bundle-item]')];
      this.addEventListener('change', (e) => {
        const select = e.target.closest('[data-bundle-select]');
        if (select) this.onSelect(select.closest('[data-bundle-item]'));
      });
      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.recalc();
    }

    /* The current choice for one item: from the selected <option>, or from the item itself when there is only one product. */
    choice(item) {
      const select = item.querySelector('[data-bundle-select]');
      const src = select ? select.options[select.selectedIndex] : item;
      if (!src) return null;
      const d = src.dataset;
      return { id: Number(select ? src.value : d.id), price: Number(d.price) || 0, available: d.available === 'true', image: d.image, thumb: d.thumb, url: d.url };
    }

    onSelect(item) {
      const c = this.choice(item);
      if (!c) return;
      const price = item.querySelector('[data-bundle-item-price]');
      if (price) price.textContent = c.available ? money(c.price) : this.dataset.labelSoldOut;
      const link = item.querySelector('[data-bundle-link]');
      if (link && c.url) link.href = c.url;
      const thumb = item.querySelector('[data-bundle-thumb]');
      if (thumb && c.thumb) thumb.src = c.thumb;
      const tile = this.querySelector(`[data-bundle-image="${item.dataset.bundleItem}"] img`);
      if (tile && c.image) { tile.removeAttribute('srcset'); tile.removeAttribute('sizes'); tile.src = c.image; }
      this.recalc();
    }

    recalc() {
      let total = 0, saving = 0, ok = this.items.length > 0;
      this.items.forEach((item) => {
        const c = this.choice(item);
        if (!c || !c.available || !c.id) { ok = false; return; }
        total += c.price;
        saving += Math.round(c.price * this.pct / 100);   // Shopify rounds a percentage discount per line
      });
      const totalEl = this.querySelector('[data-bundle-total]');
      const fullEl = this.querySelector('[data-bundle-full]');
      const saveEl = this.querySelector('[data-bundle-saving]');
      if (totalEl) totalEl.textContent = money(total - saving);
      if (fullEl) fullEl.textContent = money(total);
      if (saveEl) saveEl.textContent = (this.dataset.saveTemplate || '').replace('[amount]', money(saving)).replace('[pct]', String(Math.round(this.pct * 10) / 10));
      if (this.button) {
        this.button.disabled = !ok;
        this.button.textContent = ok ? this.dataset.labelAdd : this.dataset.labelSoldOut;
      }
      return ok;
    }

    async onSubmit(e) {
      if (!C.addToCart) return;                 // no script support: let the form post to /cart/add
      e.preventDefault();
      if (!this.recalc()) return;
      if (this.error) this.error.hidden = true;
      const items = this.items.map((item) => ({ id: this.choice(item).id, quantity: 1 }));
      try {
        await C.addToCart(items, this.button);
      } catch (err) {
        if (this.error) {
          this.error.textContent = (err && (err.description || err.message)) || (window.theme && window.theme.strings && window.theme.strings.cartError) || '';
          this.error.hidden = !this.error.textContent;
        }
      }
    }
  });
})();
